<template>
  <div class="container">
    <h1>SMS Outbox</h1>
    <div class="row margin-bottom-2">
      <div class="col-xs-4">
        <DevAppDropDownComponent role="sms" @devapp-changed="devAppChanged"/>
      </div>
    </div>
    <sdx-loading-spinner id="spinner-outbox" size="large" sr-hint="Loading. Please wait."
                         class="spinner-dashboard hidden"></sdx-loading-spinner>
    <div id="outbox" v-if="showOutbox">
      <div class="row margin-bottom-2 sms-outbox-filter" style="padding-left: 12px">
        <div style="padding-right: 1px; padding-top: 0;">
          <div style="float: left; min-width: 120px;">
            <div class="row">
              <div class="col" style="padding: 1px; padding-top: 3px;">
                <span style="padding-left: 12px; padding-right: 5px; font-size: 15px">Country Code</span>
                <sdx-menu-flyout>
                  <sdx-menu-flyout-toggle>
                    <sdx-icon icon-name="icon-information-circle" sr-hint="Read more" data-testid="infoCC"></sdx-icon>
                  </sdx-menu-flyout-toggle>
                  <sdx-menu-flyout-content style="width: 400px;">
                    <p>
                      The country code is used to filter the destination number. The country code is the first part of
                      the
                      destination number. For example, if the destination number is +41791234567, the country code is
                      CH.
                    </p>
                    <p>
                      A list of available country codes can be found on
                      <a href="https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements"
                         target="_blank">Wikipedia</a>.
                    </p>
                  </sdx-menu-flyout-content>
                </sdx-menu-flyout>
              </div>
            </div>

            <sdx-input
                placeholder="CH"
                :value="countryCode"
                @input="countryCodeChange"
            />
          </div>

        </div>
        <div class="col-xs-2" style="padding-right: 10px; padding-top: 3px;">
          <span style="padding-left: 1px; padding-right: 5px; font-size: 15px">Destination Number</span>
          <!-- `+` is removed because `destinationNumber` is indexed in Elasticsearch with
              `analyzed` setting which removes non-alphanumeric chars, among other things -->
          <sdx-input
              data-testid="DestinationNumber"
              oninput="this.value = this.value.replace(/[\\+]/g, '')"
              :value="destinationNumber"
              @input="destinationNumberChange"
          />
        </div>
        <div class="col-xs-2" style="padding-right: 10px;">
          <sdx-select
              data-testid="statusDropDown"
              label="Status"
              placeholder="Choose..."
              :value="statusFilter"
              @input="statusFilterChange"
          >
            <sdx-select-option
                v-for="(statusElem, idx) in statusList"
                data-testid="statusDropDownOption"
                v-bind:value="statusElem"
                v-bind:key="idx"
            >
              {{ statusElem }}
            </sdx-select-option>
          </sdx-select>
        </div>
        <div class="col-xs-2" style="padding-right: 10px; padding-left: 0px; padding-top: 3px;"
             v-if="envService.featureToggleSmsTag()">
          <div style="float: left; min-width: 100%;">
            <div class="row">
              <div class="col">
                <span style="padding-left: 1px; padding-right: 5px; font-size: 15px">Tag</span>
                <sdx-menu-flyout>
                  <sdx-menu-flyout-toggle>
                    <sdx-icon icon-name="icon-information-circle" sr-hint="Read more" data-testid="infoTag"></sdx-icon>
                  </sdx-menu-flyout-toggle>
                  <sdx-menu-flyout-content style="width: 600px;">
                    <p>
                      {{ $t('commons.tag') }}
                    </p>
                  </sdx-menu-flyout-content>
                </sdx-menu-flyout>
                <sdx-input
                    data-testid="tag"
                    placeholder=""
                    :value="tag"
                    @input="tagChange"
                />
              </div>
            </div>
          </div>
        </div>

        <div style="padding-right: 10px; padding-top: 3px; width: 240px">
          <span style="padding-left: 1px; padding-right: 5px; font-size: 15px">Sent Since</span>
          <sdx-menu-flyout>
            <sdx-menu-flyout-toggle>
              <sdx-icon icon-name="icon-information-circle" sr-hint="Read more" data-testid="infoSentSince"></sdx-icon>
            </sdx-menu-flyout-toggle>
            <sdx-menu-flyout-content style="width: 600px;">
              <p>
                SMS Outbox data exist only for 6 months back.
              </p>
            </sdx-menu-flyout-content>
          </sdx-menu-flyout>
          <sdx-input
              name="outboxFromDate"
              data-testid="sentSince"
              type="date"
              placeholder="01.01.2025 00:00:00"
              flatpickr-options='{"maxDate":"today", "dateFormat":"d.m.Y H:i:S", "locale":"de", "enableTime":"true", "enableSeconds":"true", "time_24hr":"true"}'
              :value="fromDate"
              @input="fromDateChange"
          />
        </div>
        <!-- https://flatpickr.js.org/options/ -->
        <div style="padding-right: 0; padding-top: 3px; width: 240px">
          <span style="padding-left: 1px; padding-right: 5px; font-size: 15px">Sent Until</span>
          <sdx-input
              name="outboxToDate"
              data-testid="sentUntil"
              type="date"
              placeholder="31.01.2025 23:59:59"
              flatpickr-options='{"maxDate":"today", "dateFormat":"d.m.Y H:i:S", "locale":"de", "enableTime":"true", "enableSeconds":"true", "time_24hr":"true", "defaultHour":"23", "defaultMinute":"59", "defaultSecond":"59"}'
              :value="toDate"
              @input="toDateChange"
          />
        </div>
      </div>
      <sdx-loading-spinner id="spinner-outbox-content" size="large"
                           sr-hint="Loading. Please wait."></sdx-loading-spinner>
      <div id="outbox-content">
        <div id="sms_outbox">
          <div class="subscription-table table table--responsive table--highlight margin-v-1">
            <div class="table_wrapper">
              <table data-init="auto">
                <thead>
                <tr>
                  <th class="table-header">Country</th>
                  <th class="table-header">Destination Number</th>
                  <th class="table-header">SMS Parts</th>
                  <th>Status
                    <sdx-menu-flyout>
                      <sdx-menu-flyout-toggle>
                        <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"
                                  data-testid="infoDS"></sdx-icon>
                      </sdx-menu-flyout-toggle>
                      <sdx-menu-flyout-content style="width: 700px;">
                        <table border="0">
                          <tr>
                            <td class="sc-blue legendStatusName">PROCESSING:</td>
                            <td> In the process of sending</td>
                          </tr>
                          <tr>
                            <td class="sc-blue legendStatusName">DELIVERED:</td>
                            <td>Successfully sent (without confirmation of receipt)</td>
                          </tr>
                          <tr>
                            <td class="sc-blue legendStatusName">CONFIRMED:</td>
                            <td>Successfully sent and confirmed by destination network or hub.<br/>(In the international context, it is not a confirmation, especially with Provider Registration) </td>
                          </tr>
                          <tr>
                            <td class="sc-blue legendStatusName">FAILURE:</td>
                            <td>Error occcured</td>
                          </tr>
                          <tr>
                            <td class="sc-blue legendStatusName">NO_INFO:</td>
                            <td>No status info</td>
                          </tr>
                          <tr>
                            <td class="sc-blue legendStatusName">BLOCKED:</td>
                            <td>Blocked (due to plan quota, throttling etc.)</td>
                          </tr>
                        </table>
                      </sdx-menu-flyout-content>
                    </sdx-menu-flyout>
                  </th>
                  <th class="table-header" v-if="envService.featureToggleSmsTag()">Tag</th>
                  <th class="table-header">Sent</th>
                  <th v-if="isAdmin" class="table-header">Delivery Details</th>
                  <th v-if="isAdmin">
                    SBS
                    <sdx-menu-flyout>
                      <sdx-menu-flyout-toggle>
                        <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"
                                  data-testid="infoSbs"></sdx-icon>
                      </sdx-menu-flyout-toggle>
                      <sdx-menu-flyout-content style="width: 600px;">
                        <p>
                          Link to SBS WebGUI with this phone number to get more detailed information about sending
                          status.
                        </p>
                      </sdx-menu-flyout-content>
                    </sdx-menu-flyout>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item) in statisticOutbox" v-bind:key="item" id="smsOutboxTr">
                  <td class="table-cell smallercells">
                    <FlagComponent :country="item['destRegionCode']"/>
                  </td>
                  <td>
                    {{ item.destination }}
                  </td>
                  <td>{{ item.amount }}</td>
                  <td>{{ item.status }}</td>
                  <td v-if="envService.featureToggleSmsTag()">
                    <p>
                      <span v-for="tagEntry in item.tagArray" :key="tagEntry"><span class="sms-tag">{{
                          tagEntry
                        }}</span>&nbsp;</span>
                    </p>
                  </td>
                  <td :title="'Last Update: ' + item.lastUpdated">{{ item.sent }}</td>
                  <td v-if="isAdmin" class="message-length">
                    <span v-for="(entry, index) in item.deliveryDetails" :key="index">
                      <template v-if="'detail' in entry && entry.detail.length > 50" >
                        <a @click="showFullContent(entry.detail)"
                           label="Show Delivery Details">
                          {{ entry.detail }}
                        </a>
                      </template>
                      <template v-else-if="'detail' in entry && entry.detail.length <= 50">
                        {{ entry.detail }}
                      </template>
                      <template v-else-if="'detailText' in entry && entry.detailText.length > 50">
                        <a @click="showFullContent(item.deliveryDetails)"
                           label="Show Delivery Details">
                       {{ entry.err}}: {{ entry.detailText }}
                          </a>
                      </template>
                      <template v-else-if="'detailText' in entry && entry.detailText.length <= 50">
                        {{ entry.err}}: {{ entry.detailText }}
                      </template>
                      <br>
                    </span>
                  </td>
                  <td class="smallercells toolbar__item item--show" v-if="isAdmin">
                    <a :href="'https://sbsweb.corproot.net/#/mtrac/%257B%2522message_type%2522%253A%2522sms%2522%252C%2522short_id%2522%253A%2522%2522%252C%2522limit%2522%253A%2522200%2522%252C%2522period%2522%253A%2522last_7d%2522%252C%2522sender%2522%253A%2522%2522%252C%2522receiver%2522%253A%2522'+ item.destination+'%2522%252C%2522start_date%2522%253A%2522%2522%252C%2522end_date%2522%253A%2522%2522%257D'"
                       target="SBS">
                      <i class="icon icon-link" aria-hidden="true" title="Summary"></i></a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if="statisticOutbox.length === 0" class="no-items-found">
          <p><i>No outbox items found</i></p>
        </div>
        <div class="Modal-Design">
          <sdx-dialog
              type="modal"
              id="delivery-details"
              label="Delivery Details Content"
              icon-name="icon-delivery-details">
            <sdx-dialog-content class="detail-Content">
              <div v-for="detail in this.deliveryDetail" :key="detail">
                <p v-if="detail.detail && detail.detailText">
                  {{ detail.detail }}
                  <br>
                  {{ detail.err}}: {{ detail.detailText }}
                </p>
                <p v-else-if="detail.detail">
                  {{ detail.detail }}
                </p>
                <p v-else-if="detail.detailText">
                  {{ detail.err}}: {{ detail.detailText}}
                </p>
              </div>
              <sdx-button-group>
                <sdx-button
                    id="first-action-element"
                    label="Close"
                    onclick="document.getElementById('delivery-details').close()"
                    theme="primary">
                </sdx-button>
              </sdx-button-group>
            </sdx-dialog-content>
          </sdx-dialog>
        </div>
        <div class="row justify-content-between">
          <div class="col-xs">
            <div v-if="totalPages != 1" class="sms-outbox-pagination">
              <div v-bind:current-page="currentPage.number + 1" v-bind:total-pages="Math.ceil(totalElements / size)"
                   @pageChanged="search">
                <ul v-if="totalPages > 0" class="pagination">
                  <li class="pagination-item">
                    <sdx-button
                        id="firstPage"
                        type="button"
                        label="<<"
                        class="sdx-button"
                        @click="gotoPage(1)"
                        :disabled="isFirstPage"/>
                  </li>
                  <li class="pagination-item">
                    <sdx-button
                        id="onePageBackwards"
                        type="button"
                        label="<"
                        class="sdx-button"
                        @click="gotoPage(currentPage - 1)"
                        :disabled="isFirstPage"/>
                  </li>
                  <li v-for="page in pages" v-bind:key="page" class="pagination-item">
                      <span
                          v-if="page.placeholder"
                          class="pagination-button inactive"
                      >
                        ...
                      </span>
                    <button
                        v-else
                        type="button"
                        class="pagination-button"
                        @click="gotoPage(page.pageNumber)"
                        :class="`${page.currentPage ? 'active' : 'inactive'}`"
                    >
                      {{ page.pageNumber }}
                    </button>
                  </li>
                  <li class="pagination-item">
                    <sdx-button
                        id="nextPage"
                        type="button"
                        label=">"
                        class="sdx-button"
                        @click="gotoPage(currentPage + 1)"
                        :disabled="isLastPage"/>
                  </li>
                  <li class="pagination-item">
                    <sdx-button
                        id="lastPage"
                        type="button"
                        label=">>"
                        class="sdx-button"
                        @click="gotoPage(totalPages)"
                        :disabled="isLastPage"/>
                  </li>
                  <li class="pagination-item total-elements">
                    Total: {{ this.totalElements }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            <div v-if="statisticOutbox.length !== 0" class="sms-outbox-export">
              <sdx-dialog
                  v-bind:id="'sms-outbox-export-modal'"
                  label="Would you like to export the search results?"
                  class="clearfix"
              >
                <sdx-dialog-toggle>
                  <sdx-button label="Export" id="ExportButton" data-testid="ExportButton"></sdx-button>
                </sdx-dialog-toggle>
                <sdx-dialog-content class="sms-outbox-export-content">
                  <div v-if="totalElements < 10000">
                    <p class="margin-bottom-1">
                      The current search results will be exported to Excel.
                    </p>
                  </div>
                  <div v-if="totalElements > 10000">
                    <p class="margin-bottom-1">
                      The current search results will be exported to Excel (Only 10'000 of {{ totalElements }} will be
                      exported).
                    </p>
                  </div>
                  <p>Generating the export may take some time.</p>
                  <p v-if="exportError" class="sms-outbox-export-modal-error">
                    {{ exportError }}
                  </p>
                  <sdx-button-group v-if="!isExporting">
                    <sdx-button
                        id="generateExport"
                        data-testid="generateExport"
                        label="Generate Export"
                        @click="exportData()"
                    ></sdx-button>
                    <sdx-button
                        id="cancel"
                        data-testid="cancel"
                        label="Cancel"
                        @click="closeModal()"
                        theme="secondary"
                    ></sdx-button>
                  </sdx-button-group>
                  <div
                      v-if="isExporting"
                      class="loader-spinner loader-spinner--large loader-spinner--plain"
                  >
                    <span class="sr-only">Exporting. Please wait.</span>
                  </div>
                </sdx-dialog-content>
              </sdx-dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utility, {addDate, formatDate} from "@/util/utility";
import DevAppDropDownComponent from "@/components/DevAppDropDownComponent";
import FlagComponent from "@/components/FlagComponent";
import envService from "@/services/env.service";
import loadingSpinnerService from '@/services/loading-spinner.service';
import { logger } from "@/services/logger.service";
import { showAlert, showSuccess } from "@/services/notification.service";
import userService from "@/services/user.service";
import smsOutboxService from '../service';

export default {
  components: {
    FlagComponent,
    DevAppDropDownComponent,
  },
  data: function () {
    return {
      webId: undefined,
      statisticOutbox: [],
      totalPages: -1,
      pageNumber: -1,
      currentPage: -1,
      totalElements: -1,
      size: -1,
      page: [],
      showOutbox: false,
      isExporting: false,
      exportError: null,
      countryCode: [],
      destinationNumber: [],
      statusFilter: [],
      tag: [],
      fromDate: formatDate(addDate(new Date(), -6, "months").setHours(0,0,0,0)),
      formattedFromDate: undefined,
      toDate: formatDate(new Date().setHours(23,59,59,999)),
      formattedToDate: undefined,
      smsMessage: [],
      messageId: [],
      delay: 1000,
      loadingData: false,
      lastLoad: '',
      isAdmin: false,
      deliveryDetail: undefined,
    }
  },
  computed: {
    pages: function () {
      let previousPage = this.currentPage > 1 ? (this.currentPage - 1) : 1
      let nextPage = this.currentPage < this.totalPages ? (this.currentPage + 1) : this.totalPages
      let extraPreviousPage = previousPage === 3 ? 2 : null
      let extraNextPage = nextPage === (this.totalPages - 2) ? (this.totalPages - 1) : null
      let placeholderBefore = previousPage > 3 ? 2 : null
      let placeholderAfter = nextPage < (this.totalPages - 2) ? (this.totalPages - 1) : null

      let pages = []

      for (let i = 1; i <= this.totalPages; i += 1) {
        if ([1, this.totalPages, this.currentPage, previousPage, nextPage, extraPreviousPage, extraNextPage, placeholderBefore, placeholderAfter].includes(i)) {
          pages.push({
            pageNumber: i,
            currentPage: this.currentPage === i,
            placeholder: [placeholderBefore, placeholderAfter].includes(i)
          })
        }
      }
      return pages
    },
    isFirstPage: function () {
      return this.currentPage === 1
    },
    isLastPage: function () {
      return this.currentPage === this.totalPages
    },
    statusList: function () {
      return ['PROCESSING', 'DELIVERED', 'CONFIRMED', 'FAILURE', 'NO_INFO', 'BLOCKED']
    },
    envService() {
      return envService
    }
  },
  mounted() {
    if (this.$route.query.tag) {
      this.tag = this.$route.query.tag;
      logger.debug("tag: " + this.$route.query.tag)
    }
    this.getAdmin();
    this.updateFromDate();
    this.updateToDate();
  },
  methods: {
    async getAdmin() {
      this.isAdmin = await userService.isAdmin();
    },
    devAppChanged: async function (webId) {
      loadingSpinnerService.show("outbox")
      this.webId = webId;
      await this.loadData(1);
      loadingSpinnerService.hide("outbox")
    },
    loadData: async function (page) {
      var thisLoad = "loadData(" + page + ") with webId: " + this.webId + ", countryCode: " + this.countryCode + ", destinationNumber: " + this.destinationNumber + ", statusFilter: " + this.statusFilter + ", tag: " + this.tag + ", fromDate: " + this.formattedFromDate + ", toDate: " + this.formattedToDate;
      logger.debug(thisLoad);
      //already loaded?
      if (thisLoad === this.lastLoad) {
        logger.debug("loadData already running/runned with same parameters")
        return
      }
      this.lastLoad = thisLoad;
      //wait for loadingData to finish
      while (this.loadingData) {
        logger.debug("waiting for loadingData to finish")
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      this.loadingData = true;
      loadingSpinnerService.show("outbox-content")
      if (this.webId === undefined || this.webId === null || this.webId === '') {
        this.showOutbox = false
      } else {
        this.showOutbox = true;
        try {
          let response = await smsOutboxService.getSmsOutbox(this.webId, this.countryCode, this.destinationNumber, this.statusFilter, this.tag, this.formattedFromDate, this.formattedToDate, page - 1, 20, "createdOn,DESC");
          this.statisticOutbox = response.data.content;
          this.totalPages = response.data.totalPages;
          this.pageNumber = response.data.pageNumber;
          this.currentPage = response.data.number + 1;
          this.totalElements = response.data.totalElements;
          this.size = response.data.size;
        } catch (error) {
          logger.debug("Error: " + error)
          showAlert(error.message)
          this.statisticOutbox = []
        }
      }
      this.loadingData = false;
      loadingSpinnerService.hide("outbox-content");
    },
    gotoPage: function (page) {
      this.loadData(page);
      this.$emit('pageChanged', page);
    },
    countryCodeChange: function () {
      this.countryCode = arguments[0].target.value;
      this.loadData(1);
    },
    destinationNumberChange: function () {
      this.destinationNumber = arguments[0].target.value;
      setTimeout(() => {
        this.loadData(1)
      }, this.delay);
    },
    statusFilterChange: function () {
      this.statusFilter = arguments[0].target.value;
      this.loadData(1);
    },
    fromDateChange: async function () {
      if (arguments[0].target.value != null) {
        this.fromDate = arguments[0].target.value;
      } else {
        this.fromDate = undefined;
      }
      await this.updateFromDate();
      await this.loadData(1);
    },
      updateFromDate: async function () {
      logger.debug("from date: " + this.fromDate)
      this.formattedFromDate = this.convertToDate(this.fromDate);
      this.formattedToDate = this.convertToDate(this.toDate);
      if (this.formattedFromDate !== null && this.formattedToDate !== null
          && this.formattedFromDate >= this.formattedToDate) {
        this.toDate = this.fromDate.replace("00:00:00", "23:59:59")
        logger.debug("change to date '" + this.toDate + "' to from date '" + this.fromDate + "'")
        this.formattedToDate = this.convertToDate(this.toDate);
      }

    },
    toDateChange: async function () {
      if (arguments[0].target.value != null) {
        this.toDate = arguments[0].target.value;
      } else {
        this.toDate = undefined;
      }
      await this.updateToDate();
      await this.loadData(1);
    },
    updateToDate: async function () {
      //set end of day
      this.toDate = this.toDate.replace("00:00:00", "23:59:59")
      this.formattedFromDate = this.convertToDate(this.fromDate);
      this.formattedToDate = this.convertToDate(this.toDate);
      if (this.formattedFromDate !== null && this.formattedToDate !== null
          && this.formattedFromDate >= this.formattedToDate) {
        this.fromDate = this.toDate.replace("23:59:59", "00:00:00")
        logger.debug("change from date '" + this.fromDate + "' to to date '" + this.toDate + "'")
        this.formattedFromDate = this.convertToDate(this.fromDate);
      }
    },
    convertToDate: function (value) {
      if (value === undefined || value == null || value.length === 0) {
        return null
      }
      let parts = value.split(' ')
      let dateParts = parts[0].split('.')
      let timeParts = parts[1].split(':')
      if (dateParts.length !== 3 && timeParts.length !== 3) {
        return null
      }
      let convertedDate = new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]), parseInt(timeParts[0]), parseInt(timeParts[1]), parseInt(timeParts[2]));
      logger.debug("convertedDate: " + convertedDate)
      return convertedDate
    },
    tagChange: function () {
      this.tag = arguments[0].target.value;
      this.loadData(1);
    },
    exportData: async function () {
      this.exportError = null
      this.isExporting = true
      try {
        const response = await smsOutboxService.getOutboxExport(this.webId, this.countryCode, this.destinationNumber, this.statusFilter, this.tag, this.formattedFromDate, this.formattedToDate);
        logger.debug("download response: " + JSON.stringify(response))
        utility.download(
            response.data,
            response.data.type,
            response.headers,
            "Sent SMS Export.xlsx"
        );
        showSuccess("Download complete")
      } catch (error) {
        this.exportError = error
        showAlert(error.message)
      }
      this.isExporting = false
      this.closeModal();
    },
    closeModal: function () {
      document.getElementById('sms-outbox-export-modal')
          .close()
      setTimeout(() => {
        this.exportError = null
      }, 150)
    },
    showFullContent: async function (deliveryDetail) {
      this.deliveryDetail = deliveryDetail;
      document.getElementById('delivery-details').open()
    }
  }
};
</script>

<style scoped>

.smallercells .td {
  padding: 5px;
}

.subscription-table .table-cell {
  padding-top: 5px;
  padding-bottom: 2px;
}

.subscription-table .table-cell {
  border-radius: 20px;
}

.subscription-table.table tbody td {
  padding-top: 5px;
  padding-bottom: 3px;
}

.table-is-loading {
  margin-top: 30px;
  margin-bottom: 30px;
}

#modal-opener:hover {
  cursor: grab;
}

#modal-opener:active {
  cursor: grabbing;
}

.total-elements {
  padding: 11px 23px;
}

.pagination {
  list-style-type: none;
}

.pagination-item {
  display: inline-block;
}

.sdx-button {
  min-width: 48px !important;
  min-height: 51px !important;
  margin-left: 2px;
  margin-right: 2px;
}

.pagination-button {
  padding: 11px 23px;
  border-radius: 5px;
  margin-left: 2px;
  margin-right: 2px;
}

.pagination-button.active {
  background-color: rgb(8, 106, 219);
  color: rgb(255, 255, 255);
  border: 1px solid rgb(8, 106, 219);
}

.pagination-button.inactive {
  background-color: rgb(207, 213, 217);
  color: rgb(51, 51, 51);
  border: 1px solid rgb(207, 213, 217);;
}

.sms-outbox-pagination {
  margin-bottom: 40px;
}

.sms-outbox-export {
  float: right;
}

.sms-outbox-export-content {
  max-width: 650px;
}

.sms-outbox-export-modal-error {
  color: rgb(228, 102, 109);
  background-color: rgba(255, 210, 210, 0.7);
  padding: 3px 12px;
  border-radius: 5px;
}

.legendStatusName {
  vertical-align: top;
}

.message-length {
  max-width: 230px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-Content {
  max-width: 50%;
}
</style>
